import { Component, input, inject, ChangeDetectionStrategy } from '@angular/core';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsTarget } from '@fcom/core-api';
import { LocalizationPipe } from '@fcom/ui-translate';

@Component({
  selector: 'fin-text-link-left',
  templateUrl: './text-link-left.component.html',
  styleUrl: './text-link-left.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TextLinkLeftComponent {
  private finLocalization = inject(LocalizationPipe);

  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly newTabText = ` (${this.finLocalization.transform('ariaLabels.newTab')})`;

  teaserTitle$ = input<Observable<string>>();
  target$ = input<Observable<CmsTarget>>();
  useIcon = input<boolean>(true);
  underline = input<boolean>(false);
}
